import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFoodAndDrinkinline = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 64 64",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M48 59V5c-6.667 2.215-10 10.882-10 26v5h10m-27-9v32m6-54v18a4 4 0 0 1-4 4h-4a4 4 0 0 1-4-4V5m4 0v15m4-15v15",
		fill: "none",
		strokeLinecap: "square",
		strokeLinejoin: "round",
		stroke: "currentColor",
		strokeWidth: 2
	})
});
export default SvgFoodAndDrinkinline;
